<script>

import NewModal from "./NewModal.vue";

export default {
    name: "ConfirmModal",
    components: {NewModal},
    props: {
        show: {
            default: false,
        },
        text: {
            default: ''
        },
        width: {
            default: '300px'
        }
    }
}
</script>

<template>
<new-modal :width="width" :show="show" @confirm="$emit('confirm')" @close="$emit('close')">
    <div slot="header">Confirmação</div>
    <div slot="body">
        {{text}}
        <slot></slot>
    </div>
</new-modal>
</template>

<style scoped>

</style>


// WEBPACK FOOTER //
// ConfirmModal.vue?56195d54